import axios from 'axios';
//axios config
axios.defaults.headers.post['Content-Type']  =  'application/x-www-form-urlencoded';
import qs from "qs";

// const accessKey = "gXMOLd6vnMmJTUOFV4oPCVBr773h--XV22moBdEdSJ8";
const accessKey = "wU9QPOKycj9ip9jWutpiPsbv0gLXLd1Q9u24HhXl-58";
const apiEndpoint = "https://api.unsplash.com/";
const randomPhotoEndpoint = `${apiEndpoint}photos/random`;

//Add the transactions for the user
const getTransactions = ({page, courseId,ordersIamIn, search,type}) => axios.post('course/getTransactions', qs.stringify({
    option: 'getTransactions',
    id_course: courseId,
    page: page,
    ordersIamIn: ordersIamIn?true:false,
    search: search,
    type: type
}));

const saveOrderDetails = ({transactionId, id_marketplace_payment_method, numberCheck, amountCheck, notes}) => axios.post('course/saveOrderDetails', qs.stringify({
    transactionId: transactionId,
    id_marketplace_payment_method: id_marketplace_payment_method,
    numberCheck: numberCheck,
    amountCheck: amountCheck,
    notes: notes    
}));
const getPaymentTypeList = () => axios.get(`course/getPaymentTypeList`);
const getCourse = ({ courseId }) => axios.get(`course/${courseId}`);
const getCourseCheckout = ({ courseId }) => axios.get(`course/${courseId}/checkout`);
const updateCourse = ({course}) => axios.put(`course/${course.id_course}`, course);
const partialUpdateCourse = ({courseId, data}) => axios.patch(`course/${courseId}`, data);
const getCoupons = ({ courseId, couponCode, }) => axios.post('course/crudCoupons', qs.stringify({
    option: 'list2',
    id_course: courseId,
    coupon_code: couponCode,
}));

const saveRefund = (refundData) => axios.post('course/crudCoursePolicyRefund', qs.stringify(refundData));
const getRefund = ({courseId}) => axios.post('course/crudCoursePolicyRefund', qs.stringify({courseId, option: 'read'}));
const saveTaxes = ({type, rate, name, id_course}) => axios.post(`course/${id_course}/tax`, {
    id_tax: type,
    value: !!name || type !== 3 ? rate : 0,
    name: name,
}, {headers: {'Content-Type': 'application/json'}});

const deleteSeat = ({seatId}) => axios.post('course/crudSeatsForCourse', qs.stringify({option: 'delete', id_course_seat: seatId}));
const saveSeat = ({body}) => axios.post('course/crudSeatsForCourse', qs.stringify(body));
const getFees =  () => axios.get('course/getFees');
const getTax =  ({id_course}) => axios.get(`course/${id_course}/tax`);
const getCourseDashboard =  ({id_course}) => axios.post('course/getCourseDashboard', qs.stringify({id_course}));
const getCustomFields = ({courseId}) => axios.post('course/crudFieldsForCourseForm', qs.stringify({id_course: courseId}));
const saveCustomField = ({body}) => axios.post('course/crudFieldsForCourseForm', qs.stringify(body));
const getCustomFieldsCategory = ({courseId}) => axios.post('course/crudCourseCategoryForm', {id_course: courseId}, {headers: {'Content-Type': 'application/json'}});
const saveCustomFieldCategory = ({customFieldsForms,customFields,courseId,isEnroll}) => axios.post('course/crudCourseCategoryForm', {is_enroll: isEnroll, id_course: courseId, customFieldsForms, customFields}, {headers: {'Content-Type': 'application/json'}});
const deleteCustomFieldCategory = ({categoryId, id_course}) => axios.delete(`course/deleteCustomFieldCategory/${categoryId}/${id_course}`);
const getCategoryByCourseForm = ({id_course}) => axios.get(`course/getCategoryByCourseForm/${id_course}`);
const getRequisites = ({ courseId }) => axios.get(`course/${courseId}/requisites`);
const deleteRequisite = ({reqId}) => axios.delete(`course/requisites/${reqId}`);
const createRequisite = ({requisite, id_course}) => axios.post(`course/${id_course}/requisites`, requisite, {headers: {'Content-Type': 'application/json'}});
const updateRequisite = ({reqId, data}) => axios.put(`course/requisites/${reqId}`, data);
const getCourseNotifications =  ({id_course}) => axios.post('course/crudCourseNotifications', qs.stringify({id_course, option: 'get'}));
const getCourseNotification =  ({id_course,id_apprendo_event}) => axios.post('course/crudCourseNotifications', qs.stringify({id_course,id_apprendo_event, option: 'get'}));
const updateCourseNotifications =  ({id_course, data}) => axios.post('course/crudCourseNotifications', qs.stringify({data,id_course, option: 'save'}));
const getFields =  ({id_course}) => axios.post('course/crudCourseNotifications', qs.stringify({id_course, option: 'getFields'}));
const getConditionFields = () => axios.post('course/crudCourseNotifications', qs.stringify({option: 'getConditionFields'}));
const getCustomFieldsByType =  ({custom_type}) => axios.post('course/crudCourseNotifications', qs.stringify({custom_type, option: 'getCustomFieldsByType'}));
const saveCourseNotification =  ({ notification}) => axios.post('course/crudCourseNotifications',
    qs.stringify({option: 'add', data: notification}));

const crudCoupons = ({data}) => axios.post('course/crudCoupons', qs.stringify(data));
const crudCourseWaitlist = ({data}) => axios.post('course/crudCourseWaitlist', qs.stringify(data));
const getSchedule = (courseId) => axios.get(`course/${courseId}/schedule`);
const coursePeople = (body) => axios.post(`reports/coursePeople`, qs.stringify(body));
const instructorsPeople = (body) => axios.post(`reports/instructorsPeople`, qs.stringify(body));
const getCourseCourses = (filters) => axios.post('course/getCourses', qs.stringify(filters), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
const getPathsFollow = () => axios.get('course/getPathsFollow');
const getCourseWaitList = (courseId) => axios.get(`course/${courseId}/waitlist`);
const updateWaitList = ({waitListId, data}) => axios.patch(`course/waitlist/${waitListId}`, data);
const getHistoryEventForm = ({objectType, id_object, filter_name, limit, offset}) => axios.get(`course/getHistoryEventForm/${objectType}/${id_object}/${filter_name}/${limit}/${offset}`);

const zoom =  () => axios.post('zoom');


const sendCourseInvites = ({courseId, users, user, notes}) => axios.post(`course/${courseId}/invite`, {
    users,
    user,
    notes: notes || null
}, {headers: {'Content-Type': 'application/json'}});

const getPhotos = () =>  axios.get(`https://api.unsplash.com/photos/?client_id=${accessKey}`);
const getSearchPhotos = ({query}) =>  axios.get(`https://api.unsplash.com/photos/random?client_id=${accessKey}&query=${query}&count=30`);
const previewTemplateSendgrid =  ({ notification}) => axios.post('course/crudCourseNotifications', qs.stringify({option: 'preview', data: notification}));
const overlappingEvents = (toVerify) => axios.post('course/overlappingEvents', toVerify, {headers: {'Content-Type': 'application/json'}});
const getPaths = (path) => axios.post('course/getPaths', path, {headers: {'Content-Type': 'application/json'}});
const addPaths = (path) => axios.post('course/addPaths', path, {headers: {'Content-Type': 'application/json'}});
const removePath = (path) => axios.post('course/removePath', path, {headers: {'Content-Type': 'application/json'}});
const updatePath = (path) => axios.post('course/updatePath', path, {headers: {'Content-Type': 'application/json'}});
const followPath = (path) => axios.post('course/followPath', path, {headers: {'Content-Type': 'application/json'}});
const unFollowPath = (path) => axios.post('course/unFollowPath', path, {headers: {'Content-Type': 'application/json'}});
const followers = (path) => axios.post('course/followers', path, {headers: {'Content-Type': 'application/json'}});
const commentPath = (path) => axios.post('course/commentPath', path, {headers: {'Content-Type': 'application/json'}});
const addLocation = (location) => axios.post('course/addLocation', location, {headers: {'Content-Type': 'application/json'}});
const getLocation = () => axios.get('course/getLocation');
const updateLocation = ({ location }) => axios.put(`course/updateLocation/${location.id_cat_location}`, location, {headers: {'Content-Type': 'application/json'}});
const cloneLocation = ({ locationId }) => axios.put(`course/cloneLocation/${locationId}`, {}, {headers: {'Content-Type': 'application/json'}});
const removeLocation = ({ locationId }) => axios.delete(`course/removeLocation/${locationId}`, {}, {headers: {'Content-Type': 'application/json'}});

const exportFollowersToExcel = async (id_course) => {
    try {
        const response = await axios({
            url: `course/${id_course}/followers/export`,
            method: 'GET',
            responseType: 'text',
            headers: {
                'Accept': 'text/csv, */*'
            }
        });

        // Extract filename from content-disposition header
        let filename = `followers_${id_course}.csv`;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
            if (filenameMatch && filenameMatch.length > 1) {
                filename = filenameMatch[1];
            }
        }

        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return { success: true };
    } catch (error) {
        console.error('Error exporting followers to CSV:', error);
        let errorMessage = 'Failed to export. Please try again.';
        if (error.response && error.response.data) {
            try {
                let errorText = error.response.data;
                if (typeof error.response.data === 'object') {
                    errorText = JSON.stringify(error.response.data);
                }
                
                try {
                    const errorJson = JSON.parse(errorText);
                    if (errorJson && errorJson.message) {
                        errorMessage = errorJson.message;
                    } else if (errorJson && errorJson.error) {
                        errorMessage = errorJson.error;
                    }
                } catch (e) {
                    if (errorText && typeof errorText === 'string' && errorText.length < 200) {
                        errorMessage = errorText; 
                    }
                }
            } catch (parseError) {
                console.error('Could not parse error response:', parseError);
            }
        }
        return { success: false, message: errorMessage };
    }
};

const searchPotentialFollowers = (id_course, term) => {
  let url = `course/${id_course}/potential_followers_search`;
  if (term && term.trim() !== '') {
    url += `?term=${encodeURIComponent(term)}`;
  }
  return axios.get(url);
};

const addFollowersToPath = (id_course, userIds) => {
  return axios.post(`course/${id_course}/add_followers`, { userIds }, {headers: {'Content-Type': 'application/json'}});
};

export default {
    zoom,
    getCourse,
    getCourseCheckout,
    getTransactions,
    saveOrderDetails,
    getPaymentTypeList,
    getCoupons,
    updateCourse,
    saveRefund,
    getRefund,
    saveTaxes,
    deleteSeat,
    saveSeat,
    getFees,
    getTax,
    getCourseDashboard,
    getCustomFields,
    saveCustomField,
    getCustomFieldsCategory,
    saveCustomFieldCategory,
    deleteCustomFieldCategory,
    getCategoryByCourseForm,
    getRequisites,
    deleteRequisite,
    createRequisite,
    updateRequisite,
    partialUpdateCourse,
    getCourseNotifications,
    updateCourseNotifications,
    saveCourseNotification,
    getCourseNotification,
    crudCoupons,
    crudCourseWaitlist,
    getSchedule,
    getFields,
    getConditionFields,
    getCustomFieldsByType,
    coursePeople,
    instructorsPeople,
    getCourseCourses,
    getPathsFollow,
    getCourseWaitList,
    updateWaitList,
    sendCourseInvites,
    getHistoryEventForm,
    getPhotos,
    getSearchPhotos,
    previewTemplateSendgrid,
    overlappingEvents,
    getPaths,
    addPaths,
    removePath,
    updatePath,
    followPath,
    unFollowPath,
    followers,
    commentPath,
    addLocation,
    updateLocation,
    cloneLocation,
    removeLocation,
    getLocation,
    exportFollowersToExcel,
    searchPotentialFollowers,
    addFollowersToPath,
};